import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store/reducers';
import { ChannelsState, ChannelState } from 'store/slices/channels';

export const channelsStateSelector = (state: RootState): ChannelsState => state.channels;

export const channelsSelector = createSelector<RootState, ChannelsState, ChannelState[]>(
  state => channelsStateSelector(state),
  channelsState => Object.values(channelsState) || []
);

export const channelByIdSelector = (channelId?: string) =>
  createSelector<RootState, ChannelsState, ChannelState | undefined>(
    state => channelsStateSelector(state),
    channelsState => (channelId ? channelsState?.[channelId] : undefined)
  );

export const channelByNameSelector = (channelName?: string) =>
  createSelector<RootState, ChannelState[], ChannelState | undefined>(
    state => channelsSelector(state),
    channels => channels.find(channel => channel.name.toLocaleLowerCase() === channelName?.toLocaleLowerCase())
  );
